<template>
    <v-alert v-model="announcement.is_active" v-if="announcement.is_active" :type="announcement.text_type"
        :color="colorMap[announcement.text_type]" class="ma-3 white--text" :dismissible="announcement.is_dismissible">
        <div class="alert-content-wrapper" style="position: relative;">
            <div class="text-h6">{{ announcement.title }}</div>
            <div v-html="announcement.description"></div>
        </div>
        <template v-if="announcement.is_dismissible" v-slot:close="{ toggle }">
            <v-btn x-small icon @click="toggle" class="close-btn bg-white rounded-full" style="position: absolute; top: 8px; right: 8px; z-index: 2;">
                <div class="text-black">X</div>
            </v-btn>
        </template>
    </v-alert>
</template>

<script>
export default {
    name: "AnnouncementAlert",
    data() {
        return {
            announcement: {
                is_active: false,
                title: "",
                description: "",
                text_type: "info",
                is_dismissible: false,
            },
            colorMap: {
                info: 'blue darken-1',
                warning: 'amber darken-1',
                success: 'green darken-1',
            }
        };
    },

    methods: {
        async getAnnouncement() {
            try {
                const { data } = await this.axios.get(
                    "/econtract/settings/announcement"
                );
                if (data.success) {
                    this.announcement = data.data;
                }
            } catch (error) {
                console.error("Error fetching announcement:", error);
            }
        },
    },
    mounted() {
        this.getAnnouncement();
    },
};
</script>